export const getSiteAffiliate = (): string => {
  const affiliate =
    document.getElementById('app')?.getAttribute('data-affiliate') ?? '';

  if (affiliate === 'uk' || affiliate === 'mmi' || affiliate === 'usa' ) {
    return affiliate.toUpperCase();
  } else {
    return affiliate.charAt(0).toUpperCase() + affiliate.slice(1);
  }
};

export const isUkAffiliate = (): boolean => {
  const affiliate = getSiteAffiliate();
  return (affiliate === 'UK') ? true : false;
};
